import { createFileRoute } from "@tanstack/react-router";

import BatchCuration from "~/pages/RecordLabelling/BatchCuration";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute(
  "/_private/record-labelling-admin/projects/$id/batches/$batchId",
)({
  staticData: ROUTE_STATIC.recordLabellingAdmin,
  component: BatchCuration,
});
